import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SubmittalClientNotesEffects } from 'src/app/root-store/account-managers-submittals-store/effects/submittals-clientnotes.effects';
import { submittalClientNotesReducer } from 'src/app/root-store/account-managers-submittals-store/reducers/submittals-clientnotes.reducers';
import { submittalClientNotesFeatureKey } from 'src/app/root-store/account-managers-submittals-store/selectors/submittals-clientnotes.selectors';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(submittalClientNotesFeatureKey, submittalClientNotesReducer),
        EffectsModule.forFeature([SubmittalClientNotesEffects])
    ]
})
export class AccountManagersSubmittalsStoreModule {}
